import React, { useState, useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";
import { FaArrowUpLong } from "react-icons/fa6";

const ScrollTop = () => {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  const [isVisible, setIsVisible] = useState(false);


  useEffect(() => {
    if (navType !== "POP") {
      window.scrollTo({ top: 0, behavior: "instant" });
    }
  }, [pathname, navType]);


  const toggleVisibility = () => {
    setIsVisible(window.scrollY > 100);
  };

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <button
      id="scroll-top"
      onClick={scrollToTop}
      className={`fixed bottom-20 right-6 bg-[#9bd66c] hover:bg-[#86bf59] text-white p-3 rounded-full shadow-lg flex items-center justify-center z-50 transition-opacity duration-300 ${
        isVisible ? "opacity-100" : "opacity-0 pointer-events-none"
      }`}
    >
      <FaArrowUpLong />
    </button>
  );
};

export default ScrollTop;